// URL utilities for the chatbot application

export const getChatbotUrl = (slug) => {
  if (process.env.NODE_ENV === 'production') {
    // Each bot is its own installable app under /chat/<slug>/
    return `/chat/${slug}/`;
  } else {
    // In development, use the current hostname with port 3000
    const hostname = window.location.hostname;
    return `http://${hostname}:3000/${slug}`;
  }
};

export const getPublicChatbotUrl = (slug, domain = null) => {
  if (process.env.NODE_ENV === 'production') {
    const currentDomain = domain || window.location.hostname;
    return `${window.location.protocol}//${currentDomain}/chat/${slug}/`;
  } else {
    // In development, use the current hostname with port 3000
    const hostname = window.location.hostname;
    return `http://${hostname}:3000/${slug}`;
  }
};

export const validateSlug = (slug) => {
  // Check if slug is valid (not empty, not just dashes)
  return slug && slug.trim() && slug !== '-' && slug.length > 1;
};